package com.nonopn.skywatcher.common.app.pages.sentinels

import com.nonopn.skywatcher.maps.LatLng
import kotlinx.serialization.Serializable

@Serializable
data class ThunderDetectionWithMetadata(
    val detection: ThunderDetection,
    val isAdministrator: Boolean,
)

@Serializable
data class ThunderDetection(
    val uuid: String,
    val name: String,
    val latitude: Double,
    val longitude: Double,
    //val fake: ProbeStatus? = null,
    //val fakeUsers: List<Pair<LatLng, Boolean>>? = null,
    // val fakeLightning: List<ThunderDetectionActivity>? = null,
    //val fakePath: List<LatLng>? = null,
    //val fakeStormPath: List<LatLng>? = null
) {
    fun position() = LatLng(
        latitude = latitude,
        longitude = longitude
    )

    companion object {
        val fakes = listOf(
            ThunderDetection(
                "fake1",
                name = "Golf Bluegreen Bordeaux Lac (Storm)",
                latitude = 44.9058125,
                longitude = -0.5707903,
                /*fake = ProbeStatus(
                    state = State.ThreatDetected,
                    alertsSent = AlertsSent(),
                    lastStateUpdatedMilliseconds = DateTime.now().unixMillisLong,
                    weatherResult = WeatherForecastFakeLightningStorm,
                    lightningActivity = emptyList(),
                    eta = EtaHolder(
                        avgKM = 60.0,
                        avgKPH = 150.0f,
                        calculatedAtSeconds = 0,
                        expectedMinutes = 10,
                        alert = "thunderstorm",
                        computed = true,
                        overhead = true
                    )
                ),*/
                //fakeUsers = FakeUsersOnMap,
                //fakeLightning = FakeLightningActivity,
                //fakePath = FakePath,
                //fakeStormPath = FakeStormPath
            ),
            ThunderDetection(
                "fake2",
                name = "Golf Bluegreen Bordeaux Lac (Storm) + validated",
                latitude = 44.9058125,
                longitude = -0.5707903,
                /*fake = ProbeStatus(
                    state = State.ThreatDetected,
                    alertsSent = AlertsSent(),
                    lastStateUpdatedMilliseconds = DateTime.now().unixMillisLong,
                    weatherResult = WeatherForecastFakeLightningStorm,
                    lightningActivity = emptyList(),
                    eta = EtaHolder(
                        avgKM = 60.0,
                        avgKPH = 150.0f,
                        calculatedAtSeconds = 0,
                        expectedMinutes = 10,
                        alert = "thunderstorm",
                        computed = true,
                        overhead = true
                    )
                ),*/
                //fakeUsers = FakeUsersOnMapWithValidations,
                //fakeLightning = FakeLightningActivity,
                //fakePath = FakePath,
                //fakeStormPath = FakeStormPath
            ),
            ThunderDetection(
                "fake3",
                name = "Golf Bluegreen Bordeaux Lac (Storm) User",
                latitude = 44.9058125,
                longitude = -0.5707903,
                /*fake = ProbeStatus(
                    state = State.ThreatDetected,
                    alertsSent = AlertsSent(),
                    lastStateUpdatedMilliseconds = DateTime.now().unixMillisLong,
                    weatherResult = WeatherForecastFakeLightningStorm,
                    lightningActivity = emptyList(),
                    eta = EtaHolder(
                        avgKM = 60.0,
                        avgKPH = 150.0f,
                        calculatedAtSeconds = 0,
                        expectedMinutes = 10,
                        alert = "thunderstorm",
                        computed = true,
                        overhead = true
                    )
                ),*/
                //fakeUsers = FakeNoUsersOnMapWithValidations,
                //fakeLightning = FakeLightningActivity,
                //fakePath = FakePath,
                //fakeStormPath = FakeStormPath
            ),
            ThunderDetection(
                "fake4",
                name = "Golf Bluegreen Bordeaux Lac User (No Alerts)",
                latitude = 44.9058125,
                longitude = -0.5707903,
                /*fake = ProbeStatus(
                    state = State.ThreatDetected,
                    alertsSent = AlertsSent(),
                    lastStateUpdatedMilliseconds = DateTime.now().unixMillisLong,
                    weatherResult = WeatherForecastFake,
                    lightningActivity = emptyList(),
                ),*/
                //fakeUsers = FakeUsersOnMap,
                //fakeLightning = emptyList(),
                //fakePath = FakePath,
            ),
            ThunderDetection(
                "fake5",
                name = "International Container Terminal Sihanoukville (Alert + Users)",
                latitude = 10.644295,
                longitude = 103.506288,
                /*fake = ProbeStatus(
                    state = State.ThreatDetected,
                    alertsSent = AlertsSent(),
                    lastStateUpdatedMilliseconds = DateTime.now().unixMillisLong,
                    weatherResult = WeatherForecastFakeLightningStorm,
                    lightningActivity = FakeLightningActivitySihanoukville,
                    eta = EtaHolder(
                        avgKM = 60.0,
                        avgKPH = 150.0f,
                        calculatedAtSeconds = 0,
                        expectedMinutes = 10,
                        alert = "thunderstorm",
                        computed = true,
                        overhead = true
                    )
                ),*/
                //fakeStormPath = SihanoukvilleFakeStormPath,
                //fakeUsers = FakeUsersOnMapForSihanoukville,
                //fakePath = FakePathSihanoukville,
            )
        ).map { ThunderDetectionWithMetadata(it, false) }
    }
}
